import {AdminType} from "../interfaces/actionTypes";
import {AdminActionType, LoginData} from "../interfaces/interfaces";
import {Dispatch} from "react";
import axios from "axios";
import Swal from "sweetalert2";

export function adminLogin(loginData: LoginData) {
  return async function (dispatch: Dispatch<AdminActionType>) {
    try {
      getLoading();
      const res = await axios.post("/user/admin/login", loginData);
      console.log(res.data);
      if (res.data.success === true) {
        return dispatch({
          type: AdminType.LOGIN,
          payload: res.data
        })
      }
      if (res.data.success === false) {
        await Swal.fire({
          icon: "error",
          text: res.data.message
        })
        return dispatch({
          type: AdminType.AUTH_ERROR,
          payload: res.data
        })
      }
    } catch (err) {
      console.log(err)
      await Swal.fire({
        icon: "error",
        text: "An error occurred, please try again"
      })
      dispatch({
        type: AdminType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function getAccounts(token: string) {
  return async function (dispatch: Dispatch<AdminActionType>) {
    const config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    try {
      getLoading()
      const res = await axios.get("/user/admin/accounts", config)
      console.log(res.data)
      if (res.status === 200) {
        return dispatch({
          type: AdminType.GET_ACCOUNTS,
          payload: res.data
        })
      }
      dispatch({
        type: AdminType.AUTH_ERROR,
        payload: res.data.msg
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: AdminType.AUTH_ERROR,
        payload: "An error occurred, please try again"
      })
    }
  }
}

export function adminLogout() {
  localStorage.removeItem("vidcom");
  return {
    type: AdminType.LOGOUT,
  };
}

export function getLoading() {
  return {
    type: AdminType.LOADING,
  };
}